<div class="col-12">
  <nav class="menu text-nowrap" tabindex="0">
    <div class="smartphone-menu-trigger"></div>
    <header class="side-avtar">
      <img src="./assets/images/logo.png" class="img-fluid" alt="...">
    </header>

    <ng-container *ngIf="moduleNavReady$ | async; else navShimmer">
      <ul>
        <a [routerLink]="DASHBOARD" *ngIf="isModuleEnabled('DASHBOARD') | async">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg"><span>Dashboard</span></li>
        </a>
        <a [routerLink]="ACTIVITY_DASHBOARD" *ngIf="isModuleEnabled('ACTIVITY_TRACKER') | async">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg"><span>Activity Board</span></li>
        </a>
        <a [routerLink]="GOVERNMENT_BUSINESS_DASHBOARD" *ngIf="isModuleEnabled('GOVERNMENT_BUSINESS_TASK') | async">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg"><span>GB Tracker</span></li>
        </a>
        <a [routerLink]="QUERY_DASHBOARD" *ngIf="isModuleEnabled('QUERIES') | async">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg"><span>Employee Queries</span></li>
        </a>
        <a [routerLink]="OFFLINE_TRACKER_SUMMARY" *ngIf="isModuleEnabled('OFFLINE_TRACKER') | async">
          <li class="icon"><img src="/assets/images/svg/right-arrow.svg" alt="right-arrow"><span>Offline Tracker</span></li>
        </a>
        <a [routerLink]="CALENDER_INFO" *ngIf="isModuleEnabled('CALENDAR') | async">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg"><span>Calendar Events</span></li>
        </a>
        <a [routerLink]="ANNOUNCEMENT" *ngIf="isModuleEnabled('CIRCULARS_AND_ANNOUNCEMENTS') | async">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg"><span>Announcements &
              Circulars</span></li>
        </a>
        <a [routerLink]="KNOWLEDGE_HUB" *ngIf="isModuleEnabled('KNOWLEDGE_BANK') | async">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg"><span>Knowledge Hub</span></li>
        </a>
        <a [routerLink]="EMPLOYEE_INFO">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg"><span>Employee Summary</span></li>
        </a>
        <a [routerLink]="DATA_REPOSITORY">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg"><span>Data Repository</span></li>
        </a>
        <a [routerLink]="REPORTS">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg"><span>Reports</span></li>
        </a>
        <a [routerLink]="SETTINGS">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg"><span>Settings</span></li>
        </a>
      </ul>
    </ng-container>

    <ng-template #navShimmer>
      <div class="shimmer-list">
        <div class="shimmer-item" *ngFor="let i of [1,2,3,4,5,6,7,8]">
          <div class="shimmer-icon"></div>
          <div class="shimmer-label"></div>
        </div>
      </div>
    </ng-template>

  </nav>
</div>
